import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { TimeBarViewType, IScheduleDocument, IScheduleShift, IScheduleDailyTimelineData, ISchedulePatternTemplate, ELoggedInUserType, IHolidayInstanceForPunch, IAssignedEmployeeConstraint, EDayOfWeek } from "../../../models"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"
import * as api from "../../../api"
import WeeklyMonthlyTimeActionBar from "../../../components/common/TimeActionBar/WeeklyMonthlyTimeActionBar"
import UserDetailScheduleMonthly from "../../../components/schedule/employee_schedule/monthly/UserDetailScheduleMonthly"
import { UserDetailScheduleWeekly } from "../../../components/schedule/employee_schedule/weekly"
import _ from "lodash"
import AppStateStore from "../../../stores/AppStateStore"
import UserStore from "../../../stores/UserStore"
import CheckAssignedEmployeeConstraintDialog from "../../../components/schedule/assign_employee/CheckAssignedEmployeeConstraintDialog"
import * as userActions from "../../../actions/UserActions"
interface IProps {
  userId: string
  scheduleStartDay: EDayOfWeek
  loggedInUserType: ELoggedInUserType
  readonly: boolean
  holidays: IHolidayInstanceForPunch[]
}
interface IState {
  viewType: TimeBarViewType
  schedules: IScheduleDocument[]
  startDate: string
  endDate: string
  showTable: boolean
  employeeConstraints: IAssignedEmployeeConstraint
}

export default class UserDetailSchedule extends React.Component<IProps, IState> {
  private callingUpdateShift: () => void
  constructor(props: IProps) {
    super(props)
    const thisWeek = timeHelper.getWeekRange(props.scheduleStartDay, moment().format())
    this.state = {
      viewType: "week",
      schedules: [],
      startDate: thisWeek.startDate,
      endDate: thisWeek.endDate,
      showTable: true,
      employeeConstraints: null,
    }
    autobind(this)
  }

  componentDidMount() {
    this.getSchedules()
  }

  initTable() {
    this.setState({ showTable: false }, () => this.setState({ showTable: true }))
  }

  getSchedules() {
    this.initTable()
    return api.getEmployeeSchedules(this.props.userId, moment(this.state.startDate).utc(true).format(), moment(this.state.endDate).utc(true).format())
      .then((res) => {
        const schedules: IScheduleDocument[] = res.data.Documents
        schedules.forEach(i => {
          i.Schedules = i.Schedules.filter(pt => !pt.Deleted)
        })
        this.setState({ schedules })
      })
  }

  checkValidateNewTimeline(shifts: IScheduleShift[], updateShiftTemplate: IScheduleShift, timelineItem: IScheduleDailyTimelineData): boolean {
    const updatedShiftTemplate = _.cloneDeep(updateShiftTemplate)
    updatedShiftTemplate.StartTime = timelineItem.StartTime
    updatedShiftTemplate.EndTime = timelineItem.EndTime
    updatedShiftTemplate.Breaks = timelineItem.Breaks
    const isOverlapValidate = scheduleHelper.checkOverlapShifts(
      updatedShiftTemplate,
      shifts.filter((item) => item.Id !== updatedShiftTemplate.Id))
    let isBreakValidate = true
    if (isOverlapValidate) {
      isBreakValidate = scheduleHelper.checkValidateShiftBreakTimes(updatedShiftTemplate)
      !isBreakValidate && AppStateStore.setProgressSnackbarContent(strings.Break_Time_Window_should_be_fall_in_shift_time)
    }
    else {
      AppStateStore.setProgressSnackbarContent(strings.Cannot_overlap_shift_times)
    }
    return isOverlapValidate && isBreakValidate
  }

  handleUpdateTimelineData(updateShift: IScheduleShift) {
    const updateSchedule = this.state.schedules.find(schedule =>
      schedule.Schedules.find(pt =>
        pt.ShiftTemplates.find(shift => {
          if (shift.Id === updateShift.Id) {
            shift.StartTime = updateShift.StartTime
            shift.EndTime = updateShift.EndTime
            shift.Breaks = updateShift.Breaks
            return true
          }
        }) ? true : false
      ) ? true : false
    )

    api.UpdateShift(updateSchedule.Id, updateShift).then(() =>
      this.getSchedules().then(() =>
        AppStateStore.setProgressSnackbarContent(strings.Shift_time_updated_successfully)
      )
    )
  }

  handleDeleteTimelineItem(deleteShift: IScheduleShift) {
    AppStateStore.setProgressSnackbarContent("loading")
    const schedule = this.state.schedules.find(schedule =>
      schedule.Schedules.find((pt, ptIndex) => {
        const targetShift = pt.ShiftTemplates.find((shift, stIndex) => {
          if (shift.Id === deleteShift.Id) {
            pt.ShiftTemplates.splice(stIndex, 1)
            return true
          }
        })
        if (pt.ShiftTemplates.length === 0) {
          schedule.Schedules.splice(ptIndex, 1)
        }
        return targetShift ? true : false
      }) ? true : false
    )

    api.DeleteShift(schedule.Id, deleteShift.Id).then(() =>
      this.getSchedules().then(() =>
        AppStateStore.setProgressSnackbarContent(strings.Shift_deleted_successfully)
      )
    )
  }

  handleUpdateTimelineItem(updateShift: IScheduleShift) {
    let updatePatternTemplate
    const schedule = this.state.schedules.find(schedule =>
      schedule.Schedules.find(pt => {
        return pt.ShiftTemplates.find((shift, index) => {
          if (shift.Id === updateShift.Id) {
            pt.ShiftTemplates[index] = updateShift
            updatePatternTemplate = pt
            return true
          }
        }) ? true : false
      }) ? true : false
    )
    this.updateShiftWithCheckEmployeeConstraint(updatePatternTemplate, schedule.Id, updateShift)
  }

  updateShiftWithCheckEmployeeConstraint(checkPatternTemplate: ISchedulePatternTemplate, scheduleId: string, updateShift: IScheduleShift) {
    this.callingUpdateShift = () => api.UpdateShift(scheduleId, updateShift).then(() =>
      this.getSchedules().then(() => {
        AppStateStore.setProgressSnackbarContent(strings.Shift_updated_successfully)
        userActions.loadUserDetails(this.props.userId)
      })
    )

    AppStateStore.setProgressSnackbarContent("loading")
    api.getEmployeeScheduleShiftConstraints(checkPatternTemplate.AssignedUserId, [checkPatternTemplate], false).then(res => {
      res.data.length === 0 ?
        this.callingUpdateShift() :
        this.setState({
          employeeConstraints: {
            SchedulePatternTemplate: checkPatternTemplate,
            Constraints: res.data,
            Employee: UserStore.getCurrentUserDetail()
          }
        }, () => AppStateStore.setProgressSnackbarContent(""))
    })
  }

  render() {
    return (
      <div>
        <div style={{ paddingLeft: 35, paddingTop: 20, fontSize: 25, fontWeight: "bold" }}>{strings.Schedule}</div>
        <WeeklyMonthlyTimeActionBar
          startDayOfWeek={this.props.scheduleStartDay}
          referenceDate={this.state.startDate}
          timeBarViewType={this.state.viewType}
          handleChangeViewType={(viewType) => this.setState({ viewType })}
          handleChangeTimeRange={(startDate, endDate) => this.setState({ startDate, endDate, schedules: [] }, () => this.getSchedules())}
        />
        <div style={{ marginTop: 30 }}>
          {this.state.showTable && (
            this.state.viewType === "week" ?
              <UserDetailScheduleWeekly
                readonly={this.props.readonly}
                referenceStartDate={this.state.startDate}
                schedules={this.state.schedules}
                holidays={this.props.holidays}
                handleUpdateTimelineData={this.handleUpdateTimelineData}
                checkValidateNewTimeline={this.checkValidateNewTimeline}
                handleDeleteTimelineItem={this.handleDeleteTimelineItem}
                handleUpdateTimelineItem={this.handleUpdateTimelineItem}
              /> :
              <UserDetailScheduleMonthly
                readonly={this.props.readonly}
                schedules={this.state.schedules}
                refereceDate={moment(this.state.startDate).toDate()}
                holidays={this.props.holidays}
                handleUpdateShift={this.handleUpdateTimelineItem}
                handleDeleteShift={this.handleDeleteTimelineItem}
                checkValidateNewTimeline={this.checkValidateNewTimeline}
              />
          )}
        </div>
        {this.state.employeeConstraints &&
          <CheckAssignedEmployeeConstraintDialog
            assignedEmployeeConstraints={this.state.employeeConstraints}
            handleClose={() => this.setState({ employeeConstraints: null })}
            handleSave={() => AppStateStore.setProgressSnackbarContent("loading", () => {
              this.setState({ employeeConstraints: null })
              this.callingUpdateShift()
            })}
          />
        }
      </div>
    )
  }
}